import { ReactNode } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

export interface InfoCardProps {
  label: string;
  value?: string | number;
  content?: ReactNode;
  loading?: boolean;
  onClick?: () => void;
}

export const InfoCard = ({ label, value, content, loading, onClick }: InfoCardProps) => (
  <Box
    onClick={onClick}
    sx={{
      flex: '1 1 250px',
      p: 2,
      borderRadius: 3,
      bgcolor: 'background.paper',
      cursor: onClick ? 'pointer' : 'default',
      '&:hover': {
        bgcolor: onClick ? 'action.hover' : 'transparent',
      },
    }}
  >
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    {loading ? (
      <Skeleton variant="text" width={100} height={25} />
    ) : (
      value && <Typography variant="body1">{value}</Typography>
    )}
    {content}
  </Box>
);

export default InfoCard;
